/**
 * Format a number as currency for display.
 * Pass the row's own currency — omitting it formats the bare number rather than
 * mislabelling foreign amounts as USD. Non-numeric input renders as an em dash.
 */
export default function formatMoney(n, currency) {
  const val = Number(n);
  if (!Number.isFinite(val)) return '—';
  const code = String(currency || '').trim().toUpperCase();
  if (!code) {
    return new Intl.NumberFormat(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(val);
  }
  try {
    return new Intl.NumberFormat(undefined, { style: 'currency', currency: code }).format(val);
  } catch {
    return `${code} ${val.toFixed(2)}`;
  }
}
